import Button from "@app/sharedComponents/Button/Button";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import {useEffect, useState} from "react";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { Image, ScrollView } from "react-native";
import LoanRenewalLogo1 from "../../../assets/Icons/LoanRenewalLogo1";
import FAQIcon from "../../../assets/Icons/FAQIcon";
import {CaretRight} from '@sharedComponents/Icons/Icons';
import { endpoints } from "@app/api/apis";
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useAppSelector } from "@app/store/hooks";
const INFO_1 ="https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png"
import { BASE_IMAGE_URL } from '../../configs/constants';
import Svg from '@app/sharedComponents/SvgImage/Svg';
import { COIN_IMG } from "../Dashboard/constant";
import ROUTE from "@app/navigationApp/routes";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import HowItWorks from "./component/HowItWork";

const FRAME_ICON =
  BASE_IMAGE_URL + 'Frame.svg';
const PleadgeMore = ({navigation})=>{
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const [buttonLoader, setButtonLoader] = useState<boolean>(false);
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);  


    useEffect(()=> {
     fetchNewApplication()
     getManageLimitConfig()
    },[])

    const getPledgeDetails = async (applicationId: string) => {
        const url = `${endpoints.pledgeDetails}${applicationId}`;
        try {
            const { data } = await axios.get(url);
            const { stepResponseObject } = data;
            const { KARVY, CAMS } = stepResponseObject.repositoryAssetMetadataMap;
    
            const dateToPick = Math.max(KARVY?.casFetchDate ?? 0, CAMS?.casFetchDate ?? 0);
    
            const selectedCreditLimit = stepResponseObject.requestCreditLimit;
            const availableToUnlock = stepResponseObject.availableCreditLimit;
            const approvedCreditLimit = stepResponseObject.additionalLimit;
            const existingCreditLimit = stepResponseObject.existingSanctionedLimit;
    
            // Use the extracted values as needed
        } catch (err) {
            console.log('newApplication', err);
        } finally {
            setIsLoading(false);
        }
    };

    const getManageLimitConfig = () => {
        const url = endpoints.manageLimitConfig + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
       
        //    navigation.navigate("MF_FETCH")


      
        }).catch((err)=>{
          console.log('newApplication',err) 
        }).finally(()=>{3
          setIsLoading(false)
        })
    
    }

    const fetchNewApplication = ()=>{
        const payload =    {
          creditApplicationType: "CREDIT_MODIFICATION_AGAINST_SECURITIES",
      }
      
        const url = endpoints.enhanceLimit + userDetails?.linkedBorrowerAccounts[0].accountId
        axios.post(url,payload).then((res)=>{
          const applicationId = res?.data?.applicationId
           AsyncStorage.setItem("application_id", applicationId)
           AsyncStorage.setItem("is_from_enhance_limit", "true")
           AsyncStorage.setItem("currentStepId", res?.data?.currentStepId)

           getPledgeDetails(applicationId)
        //    navigation.navigate("MF_FETCH")


      
        }).catch((err)=>{
          console.log('newApplication',err) 
        }).finally(()=>{
          setIsLoading(false)
        })
      }
    

      
    const openBottomSheet = () =>{
        setIsBottomSheetVisible(true);
    }

    const closeBottomSheet = () =>{
        setIsBottomSheetVisible(false);
    }
    return(
        <>
        <PageHeaders pageName="PleadgeMore" navigation={navigation} />
        <ScrollView style={{flex:1,backgroundColor:themeColorSet['bg-surface-page']}}>
            <ThemedView p="lg" backgroundColor="bg-surface-primary" mb="2xl" borderBottomWidth={1} borderColor="border-primary">
                {true?
                    <>
                <ThemedView flexDirection="row" alignItems="center" mb="lg">
                <Image source={{ uri: COIN_IMG }} style={{height: 87,width: 70,}} />
                <ThemedView ml="lg">
                    <ThemedText color='text-primary' variant='h4s'mb="xs">Increase credit limit</ThemedText>
                    <ThemedText color='text-secondary' variant='b4r'>Unlock additional limit instantly</ThemedText>
                </ThemedView>
                </ThemedView>
                <Button
                label={"Check eligible limit in 15s"}
                eventName='CHECK_ELIGIBLE_LIMIT_BUTTON'
                type={'SOLID'}
                showShadow={true}
                buttonLoader={buttonLoader}
                handlePress={()=>{}}
                showRightAccessory={true}
                rightAccessory={() => {
                    return (
                    <Svg
                        url={FRAME_ICON}
                        height={24}
                        width={24}
                    />
                    );
                }}
                />
                </> :
                <>

                
                <ThemedText variant="h4s" color="text-primary" mb="xs">Unlock additional credit limit</ThemedText>
                <ThemedText variant="b2r" color="text-secondary" mb="sm">Last fetched on 24th Apr, 2024</ThemedText>
                <ThemedView flexDirection="row" p="lg" mb="lg" borderWidth={1} borderColor="border-primary" borderRadius="lg" backgroundColor="bg-fill-primary">
                    <Image source={{uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_assets.png"}} style={{width:52,height:52}} />
                    <ThemedView>
                        <ThemedText variant="b3r" color="text-secondary">
                        Available to unlock
                        </ThemedText>
                        <ThemedView flexDirection="row" alignItems="center">
                            <ThemedText variant="l2" color="text-emphasis-secondary">
                            ₹
                            </ThemedText>
                            <ThemedText variant="h2b" color="text-emphasis-secondary">
                            6,00,000
                            </ThemedText>
                        </ThemedView>
                        
                    </ThemedView>
                </ThemedView>
                <Button label="Unlock limit" handlePress={()=>{
                }}/>
                </>
                }

            </ThemedView>
            <ThemedView p="lg" mb="2xl" flexDirection="row" alignItems="center" justifyContent="space-between" backgroundColor="bg-surface-primary" mb="2xl" borderBottomWidth={1} borderTopWidth={1} borderColor="border-primary">
                <ThemedView>
                    <ThemedText variant="b3m" color="text-primary" mb="xs">Existing credit limit</ThemedText>
                    <ThemedText variant="b3m" color="text-emphasis-secondary">₹ 25,592</ThemedText>
                </ThemedView>
                <Button type="TEXT" handlePress={()=>{}} label="View details" showRightAccessory={true} rightAccessory={()=> <CaretRight size="16" color={themeColorSet['text-action-primary']} />}/>
            </ThemedView>
            <ThemedView>
            <ThemedView my="lg" borderTopWidth={1} borderColor="border-primary" borderBottomWidth={1} backgroundColor="bg-surface-primary">
                <ThemedPressable onPress={openBottomSheet}  flexDirection="row" justifyContent="space-between" p="lg">
                    <ThemedView flexDirection="row" alignItems="center">
                        <LoanRenewalLogo1/>
                        <ThemedText variant="b3m" color="text-primary" ml="sm">See how renewal works</ThemedText>
                    </ThemedView>
                    <CaretRight size={16} />
                </ThemedPressable>
                <ThemedPressable onPress={()=>navigation.navigate(ROUTE.FAQ)} flexDirection="row" justifyContent="space-between" p="lg" borderTopWidth={1} borderColor="border-primary" >
                    <ThemedView flexDirection="row" alignItems="center">
                        <FAQIcon size={24}/>
                        <ThemedText variant="b3m" color="text-primary" ml="sm">FAQ</ThemedText>
                    </ThemedView>
                    <CaretRight size={16} />
                </ThemedPressable>
            </ThemedView>
            </ThemedView>
        </ScrollView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
        >
            <HowItWorks/>
        </BottomSheetContainer>
        </>
    )
}

export default PleadgeMore;